import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import { SocketioService } from '../../socketio.service';
import { ViewChild } from '@angular/core';
import { NbDialogService, NbStepperComponent } from '@nebular/theme';
import { EnvService } from '../../env.service';
import { HttpClient } from '@angular/common/http'
import { debounceTime } from 'rxjs/operators';
import { PasswordDialogComponent } from 'src/app/password-dialog/password-dialog.component';


@Component({
  selector: 'app-hub-replacement',
  templateUrl: './hub-replacement.component.html',
  styleUrls: ['./hub-replacement.component.css']
})
export class HubReplacementComponent implements OnInit {

  @ViewChild('stepper') stepper: NbStepperComponent;

  fromHubId = sessionStorage.getItem('fromHubId')
  toHubId = sessionStorage.getItem('toHubId')
  custId = ""
  custData = {};
  hubs = [];
  hubData = {};
  showSummary = false
  replacementInProgess = false
  replacementStatus = {
    status: "Replacement request initiated"
  }
  replacementType = 0
  deductWarranty = true;

  private custDataSub: Subscription;
  private replacementButtonClicked = new Subject<string>();



  constructor(public socketService: SocketioService, private router: Router, public userDetails: UserDetailComponent, private env: EnvService, private route: ActivatedRoute, private http: HttpClient,private dialogService:NbDialogService) {
    this.custDataSub = this.userDetails.getCustInfoDataListener().subscribe(
      custDataStatus => {
        console.log(custDataStatus);
        console.log(this.userDetails.customersData)
        this.custData = this.userDetails.customersData
        let hubs = this.custData['hubs']

        hubs.forEach((hub)=>{
          this.hubData[hub.hubId] = hub;
        })
      }
    );

   }



  ngOnInit(): void {
    const replacementButtonClickedDebounced =   
      this.replacementButtonClicked.pipe(debounceTime(200));

      replacementButtonClickedDebounced.subscribe((itemId: string) =>
      //The actual action that should be performed on click
      {
        //  this.itemStorage.get(itemId);
        if(itemId == 'retry') {
          this.retryReplacement();
        } else {
          this.startReplacement();
        }
      }
   );
      
    this.route.params.subscribe(params => {
      this.custId = params.custId
      console.log(params.custId)
      this.verifyUser()
    });
  }

  ngOnDestroy() {
    if(this.socketService)
      this.socketService.disconnect()
  }

  toggledeductWarranty(checked){
    this.deductWarranty = checked;
  }

  verifyUser() {

    this.dialogService.open(PasswordDialogComponent)
    .onClose.subscribe((password: string | null) => {
      if (password !== null) {
        this.http.post(this.env.apiUrl + "/api/users/verifyUserPin", { pin: password,feature:"hubReplacement" })
        .subscribe(response => {
          console.log(response)
          this.userDetails.showToast(3000, response['message'], 'validating')
          this.userDetails.fetchCustomerData(this.custId, true,false);
        }, err => {
          console.log(err)
          // this.verifyUser()
          setTimeout(() => {
            this.userDetails.showToast(3000, err['message'], 'reloading page')
            location.reload()
          }, 3000);
        })
      } else {
        
      }
    });

  }


  validateHubs() {
    // sessionStorage.setItem("fromHubId", this.fromHubId)
    // sessionStorage.setItem("toHubId", this.toHubId)
    return (this.checkNodesInNewHub() && this.checkNewHubStatus()) && this.checkOldHubStatus() && this.checkHubsPlaceIds()
  }

  checkNodesInNewHub() {
    return this.hubData[this.toHubId]['nodes'].length == 0
  }

  checkNewHubStatus() {
    return this.hubData[this.toHubId]['isOnline'] == true
  }

  checkHubsPlaceIds() {
    return this.hubData[this.toHubId]['placeId'] == this.hubData[this.fromHubId]['placeId']
  }

  checkOldHubStatus() {
    // if(this.replacementType == 2) {
    //   return this.hubData[this.fromHubId]['isOnline'] == true
    // } else if(this.replacementType == 1) {
    //   return this.hubData[this.fromHubId]['isOnline'] == false
    // }
    return this.hubData[this.fromHubId]['isOnline'] == false
  }

  public startOrRetryReplacementWithClickHandle(itemId: string) {
    this.replacementButtonClicked.next(itemId);
 }
 
  startReplacement() {
    if(this.validateHubs()) {
      this.replacementInProgess = true
      const replacementInfo = this.fromHubId + "|" +  this.toHubId + "|" + this.custId
      let isToHubPro = (this.hubData[this.toHubId].ipType && this.hubData[this.toHubId].ipType == 2) || this.hubData[this.toHubId].type == 125 || this.hubData[this.toHubId].type == 126;
      this.socketService.createReplacementRoom(replacementInfo)
      this.socketService.startReplacement(replacementInfo, this.hubData[this.fromHubId]['nodes'].length, isToHubPro).subscribe(response => {
        if (response) {
          console.log(response)
          this.replacementStatus = response;
          if(response && response['done']) {
            this.socketService.disconnect()
            this.userDetails.showToast(3000, "Replacement Completed", "Redirecting to the user detail page.");
            
            if(this.deductWarranty) {
              this.userDetails.showToast(3000, "Warranty Deduction", "Deducting Warranty.");
              this.http.post(this.env.apiUrl + "/api/hubTransfer/deductWarranty", { oldEid:this.fromHubId,newEid:this.toHubId })
              .subscribe(response => {
                setTimeout(() => {
                  this.router.navigate(['user', this.custId])
                }, 3000);
              }, err => {
                console.log(err)
                setTimeout(() => {
                  this.router.navigate(['user', this.custId])
                }, 3000);
              })
            }else {
              setTimeout(() => {
                this.router.navigate(['user', this.custId])
              }, 3000);
            }
          }
        }
      },
      err => console.error('Observer got an error: ' + err),
      () => console.log('Observer got a complete notification'));
    } else {
      this.userDetails.showToast(3000, "Validation Failed", "Make sure the New Hub is online and there are no nodes and both HUBs are in Same Place.");
    }
  }

  retryReplacement() {
    this.replacementInProgess = true
    const replacementInfo = this.fromHubId + "|" +  this.toHubId + "|" + this.custId
    let isToHubPro = (this.hubData[this.toHubId].ipType && this.hubData[this.toHubId].ipType == 2) || this.hubData[this.toHubId].type == 125

    this.socketService.resumeReplacement(replacementInfo, this.replacementStatus['step'],  this.hubData[this.fromHubId]['nodes'].length, isToHubPro)
  }






}
